import React from 'react'
import ComingSoon from '../../components/comingSoon/ComingSoonPage'

const Dashboard = () => {
  return (
   <>
   <ComingSoon/>
   </>
  )
}

export default Dashboard